import { createAction, props } from '@ngrx/store';
import { MinorTransferState } from '@store/reducers/minor-transfer/minor-transfer.reducer';

export const UpdateMinorTransferSelectedAccountFrom = createAction(
  '[Minor Transfer] Update Account From Status Selection',
  props<{ payload: MinorTransferState['transferFrom'] }>(),
);

export const UpdateMinorTransferSelectedAccountTo = createAction(
  '[Minor Transfer] Update Account To Status Selection',
  props<{ payload: MinorTransferState['transferTo'] }>(),
);

export const UpdateMinorTransferTotalTransferValue = createAction(
  '[Minor Transfer] Update Total Transfer Value',
  props<{ payload: string }>(),
);

export const MinorContinue = createAction('[Minor Continue] Minor Overview: Continue');
